import { apiErrorHandler } from '../../../utils/api-error-handler.ts'
import { rundownApi } from '../../../axios'
import type {
  GetMentionsParams,
  CreateMentionParams,
  GetMentionParams,
  UpdateMentionParams,
  DeleteMentionParams,
} from '../model/params'
import type { MentionDto } from '../model/dtos'

const buildBase = (rundownId: string) => `/${rundownId}/mentions`

export const getMentions = async ({ rundownId }: GetMentionsParams) => {
  return apiErrorHandler(rundownApi.get<MentionDto[]>(buildBase(rundownId)))
}

export const createMention = async ({
  rundownId,
  payload,
}: CreateMentionParams) => {
  return apiErrorHandler(rundownApi.post(buildBase(rundownId), payload))
}

export const getMention = async ({
  rundownId,
  mentionId,
}: GetMentionParams) => {
  return apiErrorHandler(
    rundownApi.get(`${buildBase(rundownId)}/${mentionId}`),
    {
      toast: false,
    },
  )
}

export const updateMention = async ({
  rundownId,
  mentionId,
  payload,
}: UpdateMentionParams) => {
  return apiErrorHandler(
    rundownApi.patch(`${buildBase(rundownId)}/${mentionId}`, payload),
  )
}

export const deleteMention = async ({
  rundownId,
  mentionId,
}: DeleteMentionParams) => {
  return apiErrorHandler(
    rundownApi.delete(`${buildBase(rundownId)}/${mentionId}`),
  )
}
